<form #f="ngForm" (keydown.enter)="(false)">
  <div fxLayout="column" fxLayoutGap="16px">
    <h1 mat-dialog-title>{{ (editMode ? 'global.edit_end_user' : 'global.add_end_user') | translate }}</h1>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'global.company_id' | translate }}"
          [(ngModel)]="endUser.organization"
          name="id"
          [disabled]="editMode"
          required
          gtAlphanumericValidator
          gtMaxCharactersValidator
          #id="ngModel"
        />
        <mat-error>{{ id.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'global.login' | translate }}"
          [(ngModel)]="endUser.login"
          name="login"
          [disabled]="editMode"
          required
          gtAlphanumericValidator
          gtMaxCharactersValidator
          #login="ngModel"
        />
        <mat-error>{{ login.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="editMode">
        <input
          matInput
          placeholder="{{ 'contacts.col_number' | translate }}"
          value="{{ endUser.fullNumber | phoneNumberFormatter }}"
          name="fullNumber"
          [disabled]="true"
        />
      </mat-form-field>
      <mat-form-field *ngIf="!editMode">
        <input
          matInput
          placeholder="{{ 'contacts.col_number' | translate }}"
          [(ngModel)]="endUser.fullNumber"
          name="fullNumber"
          [disabled]="editMode"
          #fullNumber="ngModel"
          required
          gtPhoneNumberValidator
        />
        <mat-error>{{ fullNumber.errors?.message | translate }}</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutGap="16px">
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'contacts.col_firstname' | translate }}"
          [(ngModel)]="endUser.firstName"
          name="firstName"
          #firstName="ngModel"
        />

        <mat-error>{{ firstName.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'contacts.col_lastname' | translate }}"
          [(ngModel)]="endUser.lastName"
          name="lastName"
          #lastName="ngModel"
        />
        <mat-error>{{ lastName.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="{{ 'contacts.col_short' | translate }}"
          [(ngModel)]="endUser.shortNumber"
          name="shortNumber"
          #shortNumber="ngModel"
        />
        <mat-error>{{ shortNumber.errors?.message | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          email
          placeholder="{{ 'contacts.col_email' | translate }}"
          [(ngModel)]="endUser.email"
          name="email"
          #email="ngModel"
        />
        <mat-error>{{ email.errors?.message | translate }}</mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutGap="16px">
      <mat-checkbox [(ngModel)]="endUser.administrator" name="administrator" color="primary">
        {{ 'admin.end_user.col_administrator' | translate }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="endUser.blocked" name="blocked" color="primary">
        {{ 'admin.end_user.col_blocked' | translate }}
      </mat-checkbox>
    </div>
    <gt-end-user-terminal-list fxFill [endUser]="endUser"></gt-end-user-terminal-list>

    <div fxLayout="row" fxLayoutGap="5px">
      <button mat-button (click)="onCancelClick()" color="primary" class="btn btn-default">
        {{ 'global.cancel' | translate }}
      </button>
      <button mat-raised-button (click)="onSaveClick()" color="primary" class="btn btn-default" [disabled]="f.invalid">
        {{ 'global.save' | translate }}
      </button>
    </div>
  </div>
</form>
